import Thumbnail from './thumbnail.png';

const title = 'Architectural Model of the Bundeswehr History Museum';
const description =
  'For my final project in HIAA 0860: Contemporary Architecture at Brown, I modeled the Bundeswehr Military History Museum in Dresden, Germany.';

export default {
  title,
  description,
  thumbnail: Thumbnail,
  href: 'https://www.youtube.com/watch?v=rQs6ijd8Ok0',
};
